const { pick, find, mapValues } = require('lodash');
module.exports = {
	name: 'child[]',
	validation(yup, { models, fieldDef, buildSchemaFromFields }) {
		const {
			childModelName,
			childFields,
			positiveWhenNewFields = []
		} = fieldDef.options;
		const { fields: childModelFields } = find(
			models,
			model => model.name === childModelName
		);
		const fields = mapValues(
			pick(childModelFields, childFields),
			(childField, name) =>
				positiveWhenNewFields.includes(name)
					? {
							...childField,
							options: { ...childField.options, positiveWhenNew: true }
					  }
					: childField
		);
		const schema = yup.array().of(buildSchemaFromFields({ fields }));
		return schema;
	}
};
